import { theme } from 'antd';
import React, { useEffect, useState } from 'react';
import { useManagePermittedRoles } from 'library/hooks';
import { useDispatch, useSelector } from 'react-redux';
import { peopleActions } from 'reduxStore/people/slice';
import { selectPeopleByPersonID } from 'reduxStore/people/selectors';
import { selectSites } from 'reduxStore/sites/selectors';
import { Typography } from 'zui/Antd';
import { SelectFontSizeLG } from 'zui/Antd/Select';
import RemoveSitePersonModal from 'zComponents/molecules/RemoveSitePersonModal';

const { Text } = Typography;

const EditSiteSelect = ({ personID }) => {
	const {
		token: { fontSizeLG, colorPrimary }
	} = theme.useToken();
	const dispatch = useDispatch();
	const isGlobalAdmin = useManagePermittedRoles('manageSiteAssignment');
	const canEdit = useManagePermittedRoles('managePersonSites');

	const sites = useSelector(selectSites);
	const person = useSelector((state) => selectPeopleByPersonID(state, personID));

	const siteIDs = person?.sites?.map((s) => s.siteID) || [];

	const [editableSiteIDs, setEditableSiteIDs] = useState(siteIDs);
	const [removeModalVisible, setRemoveModalVisible] = useState(false);
	const [siteIDsToRemove, setSiteIDsToRemove] = useState([]);

	useEffect(() => {
		setEditableSiteIDs(siteIDs);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [person?.sites]);

	const handleSelectChange = (newValue) => {
		const removed = editableSiteIDs.filter((id) => !newValue.includes(id));

		if (removed.length > 0) {
			setSiteIDsToRemove(removed);
			setRemoveModalVisible(true);
			return;
		}

		setEditableSiteIDs(newValue);
		dispatch(peopleActions.updatePersonSites({ personID, siteIDs: newValue }));
	};

	const options = sites.map((site) => ({
		label: site.name,
		value: site.siteID
	}));

	// Global admin can always edit; site admin only when they have multiple sites
	const showSelect = isGlobalAdmin || (canEdit && sites.length > 1);

	if (!showSelect) {
		const siteNames = person?.sites?.map((s) => s.name).join(', ');
		return <Text style={{ fontSize: fontSizeLG }}>{siteNames || '-'}</Text>;
	}

	return (
		<>
			<SelectFontSizeLG
				mode='multiple'
				value={editableSiteIDs}
				onChange={handleSelectChange}
				placeholder='Select Sites'
				options={options}
				showSearch={false}
				virtual={false}
				maxTagCount={1}
				maxTagPlaceholder={(omittedValues) => `+${omittedValues.length}`}
				$tagColor={colorPrimary}
				style={{ minWidth: 228, maxWidth: 400 }}
				allowClear
			/>
			<RemoveSitePersonModal
				personID={personID}
				siteIDs={siteIDsToRemove}
				visible={removeModalVisible}
				setVisible={setRemoveModalVisible}
			/>
		</>
	);
};

export default EditSiteSelect;
